import { ArrowBackIcon } from "@l2r-front/l2r-icons"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { useIsMobileDevice } from "../../hooks/useIsMobileDevice"

import * as Styled from "./UiModal.styled"

export function UiModal(props) {

    const isMobile = useIsMobileDevice()

    const {
        buttons,
        className,
        children,
        desc,
        handleBack,
        height,
        interactive,
        open,
        onClose,
        title,
        titleIcon,
        width,
    } = props

    return <Styled.Modal
        id="linear-edit-modal"
        interactive={interactive}
        open={open}
        onClose={onClose}
    >
        <Styled.Box height={height} width={width} isMobile={isMobile} className={className}>
            <Styled.Header>
                {handleBack && <Styled.BackButton color="objects/object-black" onClick={() => handleBack?.()}>
                    <ArrowBackIcon color="objects/object-black" />
                </Styled.BackButton>}
                {titleIcon && <Styled.TitleIcon>{titleIcon}</Styled.TitleIcon>}
                <Styled.Title variant="H1" noWrap>{title}</Styled.Title>
                <Styled.IconButton id="close-button" onClick={onClose}>
                    <Styled.CloseIcon />
                </Styled.IconButton>
            </Styled.Header>
            {desc && <Styled.Desc variant="H4">{desc}</Styled.Desc>}
            <Styled.Content>
                {buttons ? <Styled.Layout buttons={buttons} content={children} /> : children}
            </Styled.Content>
        </Styled.Box>
    </Styled.Modal>
}

UiModal.propTypes = {
    buttons: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    desc: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    interactive: PropTypes.bool,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    titleIcon: PropTypes.node,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

UiModal.defaultProps = {
    buttons: null,
    className: "",
    desc: "",
    height: "80%",
    width: "80%",
    interactive: true,
    titleIcon: null,
}
